import { render, staticRenderFns } from "./ArticlesBlock.vue?vue&type=template&id=641443e2&"
import script from "./ArticlesBlock.vue?vue&type=script&lang=js&"
export * from "./ArticlesBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default})
